import React from 'react';

const MoonLoader = () => <div className="moon-loader"></div>;

export default MoonLoader;
